import React from 'react';

import styles from '../CopilotPage.module.scss';

const CopilotError: React.FC = () => {
	return (
		<div className={styles['blurb']}>
			We are sorry about the inconvenience but we've enountered an error.
			Please try refreshing the page or if the issue persists, please
			contact us at <a href="mailto:alex@asaph.io">alex@asaph.io</a>
		</div>
	);
};

export default CopilotError;
